export default function identity<T>(val: T): T {
  return val;
}
